export default class SetPasswordModel {
  username='';

  password = '';

  newPassword = '';

  checkPassword = '';
}
